import { TextInput } from '@mantine/core'
import TextInputClasses from './styles.module.css'
import '../../styles/variables.css'

export default TextInput.extend({
    defaultProps: { radius: 'lg', size: 'var(--gm-text-input-height)' },
    classNames: TextInputClasses,
})
